<style lang="less" scoped>
  .index {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    h1 {
      height: 80px;
      img {
        height: 100%;
      }
    }
    .ivu-row-flex {
      height: 100%;
    }
    .login_form {
      width: 100%;
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>
<template>
  <div>
    <!-- <Carousel class="index" ref="carousel" easing="fade" :height="height" autoplay :autoplaySpeed="20000" v-model="config.index">
      <CarouselItem v-for="(item,index) in page.loginBgImg" :key="index">
        <div class="index bg-white" :style="{backgroundImage:'url(' + (item.indexOf('static') > -1 ? item : item|img_oss('tubo_large')) + ')',backgroundRepeat:'no-repeat'}"></div>
      </CarouselItem>
    </Carousel> -->
    <div class="index bg-white bgLogin" :style="{backgroundImage:'url(img/sysLogin.jpg' + ')',backgroundRepeat:'no-repeat',backgroundSize: '100% 100%'}"></div>
    <div class="index">
      <Row type="flex" justify="center" align="middle">
        <Col span="5" style="min-width:400px">
        <div class="p-l-30 p-r-30 p-t-24 p-b-15 brd-5" :style="{'background-color': 'rgba(255,255,255,0.9)'}">
          <div class="f-24 f-700">{{page.title}}</div>
          <div class="f-16 f-700 m-t-5">{{page.subtitle}}</div>
          <div class="login_form">
            <Tabs v-model="tabType" :animated="false">
              <Tab-pane label="密码登录" name="1">
                <Form ref="accountForm" :model="accountForm" :rules="accountFormRule">
                  <Form-item prop="regAccount">
                    <Input class="m-t-10" type="text" v-model="accountForm.regAccount" @on-enter="login">
                    <Icon type="md-person" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                    </Input>
                  </Form-item>
                  <Form-item prop="pass">
                    <Input type="password" v-model="accountForm.pass" @on-enterr="login">
                    <Icon type="md-lock" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                    </Input>
                  </Form-item>
                  <Form-item prop="kaptchaCode">
                    <Row>
                      <Col span="18">
                      <Input type="text" v-model="accountForm.kaptchaCode" @on-enter="login">
                      <Icon type="md-text" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                      </Input>
                      </Col>
                      <Col class="c-h" span="6" @click.native="reCode" style="height:30px;margin-top:1px">
                      <img :src="url + uuid" height="32px" class="brd-5">
                      </Col>
                    </Row>
                  </Form-item>
                </Form>
              </Tab-pane>
              <Tab-pane label="短信验证" name="2">
                <Form ref="mobileForm" :model="mobileForm" :rules="mobileFormRule">
                  <Form-item prop="regMobile">
                    <Input class="m-t-10" type="text" v-model="mobileForm.regMobile" @on-enter="login">
                    <Icon type="md-person" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                    </Input>
                  </Form-item>
                  <Form-item prop="kaptchaCode">
                    <Row>
                      <Col span="18">
                        <Input type="text" v-model="mobileForm.kaptchaCode" @on-enter="login">
                          <Icon type="md-text" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                        </Input>
                      </Col>
                      <Col class="c-h" span="6" @click.native="reCode" style="height:30px;margin-top:1px">
                        <img :src="url + uuid" height="32px" class="brd-5">
                      </Col>
                    </Row>
                  </Form-item>
                  <Form-item prop="smsCode">
                    <Row :gutter="5">
                      <Col span="16">
                      <Input type="text" v-model="mobileForm.smsCode" @on-enter="login">
                      <Icon type="md-lock" class="p-l-5 p-r-5 f-20" slot="prepend"></Icon>
                      </Input>
                      </Col>
                      <Col span="8">
                      <Button type="primary" ghost class="w-100" @click.native="sendSms" :disabled="countDown.disable">{{countDown.text}}</Button>
                      </Col>
                    </Row>
                  </Form-item>
                </Form>
              </Tab-pane>
            </Tabs>
            <Form>
              <Form-item>
                <Button type="primary" class="p-l-30 p-r-30" @click="login">登&nbsp;&nbsp;录</Button>
              </Form-item>
            </Form>
          </div>
        </div>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
  import md5 from "md5";
  import { mapState } from "vuex";
  import store from "@/modules/third";
  import { _api, util } from "@/libs";
  import { config } from "@/config";
  export default {
    data() {
      return {
        config: {
          index: 0,
          photoUrl: _api.photoUrl
        },
        tabType: "1",
        url: _api.baseUrl + _api.common.libUtil.kaptcha,
        uuid: util.uuid(),
        accountForm: { regAccount: "", pass: "", kaptchaCode: "" },
        mobileForm: { regMobile: "", smsCode: "", kaptchaCode: '' },
        accountFormRule: {
          regAccount: [{ required: true, trigger: "blur", pattern: config.pattern.regName, message: "请输入登录用户名" }],
          pass: [{ required: true, pattern: config.pattern.pass, trigger: "blur", message: "请输入登录密码" }],
          kaptchaCode: [{ required: true, pattern: config.pattern.sms, trigger: "blur", message: "请输入正确的验证码" }]
        },
        mobileFormRule: {
          regMobile: [{ required: true, pattern: config.pattern.phone, trigger: "blur", message: "请输入正确的手机号" }],
          kaptchaCode: [{ required: true, pattern: config.pattern.sms, trigger: "blur", message: "请输入正确的图形验证码" }],
          smsCode: [{ required: true, pattern: config.pattern.sms, trigger: "blur", message: "请输入正确的验证码" }]
        }
      };
    },
    computed: {
      ...mapState({
        countDown: state => state.third.countDown,
        page: state => state.ivew.config.baseJson
      }),
      height: () => window.innerHeight
    },
    methods: {
      loginSuccess(res) {
        this.$router.addRoutes(this.$store.state.sysUser.routers);
        this.$router.push({ path: this.$route.query.redirect || "/system/index" });
        this.$forceUpdate()
      },
      reCode() {
        this.uuid = util.uuid();
      },
      login() {
        if (this.tabType === '1') {
          this.$refs.accountForm.validate(valid => {
            if (valid) {
              this.$store.dispatch("sysUser/loginSysRegName", {
                regAccount: this.accountForm.regAccount,
                regPassMd5: md5(this.accountForm.pass),
                kaptchaCode: this.accountForm.kaptchaCode,
                kaptchaUuid: this.uuid
              }).then(this.loginSuccess, this.reCode);
            }
          });
        } else {
          this.$refs.mobileForm.validate(valid => {
            if (valid) {
              this.$store.dispatch("sysUser/loginSysSmsCode", { regMobile: this.mobileForm.regMobile, smsCode: this.mobileForm.smsCode }).then(this.loginSuccess, this.reCode);
            }
          });
        }
      },
      sendSms() {
        if (config.pattern.phone.test(this.mobileForm.regMobile)) {
          this.$store.dispatch("third/thirdSmsCodeSendKaptcha", { mobile: this.mobileForm.regMobile,uuid: this.uuid,code: this.mobileForm.kaptchaCode })
            .then(() => this.reCode(),() => this.reCode())
        }
      }
    }
  };
</script>
